import request from '../../axios';
import {IPostStoreOrderDeliveredPayload} from './usePostStoreOrderDelivered';

const postStoreOrderDelivered = async (
  payload: IPostStoreOrderDeliveredPayload,
) => {
  const {orderGuid, ...rest} = payload;
  await request.post(
    `/api/v2/order/store-approve-order-deliver/${orderGuid}`,
    rest,
  );
};

export default postStoreOrderDelivered;
